function u(t){var e=null,r=null,o=new Promise(function(n,c){e=n,r=c});return t&&t.then(function(n){e&&e(n)},function(n){r&&r(n)}),{promise:o,resolve:function(n){e&&e(n)},reject:function(n){r&&r(n)},cancel:function(){e=null,r=null}}}export{u as createImperativePromise};
//# sourceMappingURL=index.es.js.map
